module.exports = __webpack_public_path__ + "img/80.0491dc1b.jpg";